import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from 'state/modules/assign';
import { clone } from 'lodash';
import styles from './PopupDuplicateInspections.css';

const debug = _debug('app:PopupDuplicateInspections');
class PopupDuplicateInspections extends Component {
  static propTypes = {
    closeModal: React.PropTypes.func,
    wholeData: React.PropTypes.shape({}),
    inspectionsDataAll: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    updateInspectionsDisposition: React.PropTypes.func,
    strings: React.PropTypes.shape({}),
    updateInspectionsData: React.PropTypes.func,
    ownerId: React.PropTypes.string
  };

  constructor(props) {
    debug(props);
    super(props);
  }

  updateInspectionData = () => {
    const inspectionData = this.props.wholeData;
    const dataId = inspectionData.id;
    let correctData = {};
    const dataToUpdate = [{ suppressDuplicateErrors: 1, updates: [] }];
    const ownerId = this.props.ownerId;
    const dataDict = {
      action: 'U',
      fields: {},
      modelName: 'cica_inspections',
      modelId: dataId
    };
    this.props.inspectionsDataAll.forEach((data) => {
      if (data.id.indexOf(dataId) > -1) {
        correctData = clone(data);
        correctData.cica_isduplicate = 1; // eslint-disable-line
        correctData.cica_issubmitted = 1; // eslint-disable-line
        dataDict.fields.cica_issubmitted = true; // eslint-disable-line
        dataDict.fields.cica_isduplicate = true;
        dataDict.fields.cica_disposition = 4;
        dataDict.fields.cica_comments =
        correctData.cica_comments ? correctData.cica_comments : null;
        correctData.cica_customerexperience = null;
        correctData.cica_couldnotcntowner = null;
        correctData.cica_trainingopportunity = null;
        dataDict.fields.cica_customerexperience = null;
        dataDict.fields.cica_couldnotcntowner = null;
        dataDict.fields.cica_trainingopportunitystr = null;
        dataToUpdate[0].updates.push(dataDict);
      }
    });
    this.props.updateInspectionsData(correctData);
    const assignmentCompleteCB = () => {
      this.props.closeModal(true);
    };
    this.props.updateInspectionsDisposition(dataToUpdate, ownerId)
    .then(assignmentCompleteCB)
    .catch((error) => {
      debug(error);
    });
  }

  render() {
    debug('### this.props.wholeData', this.props.wholeData);
    const { strings } = this.props;
    return (
      <div className={styles.popupBody}>
        <div className={styles.inputContainer}>
          <span className={styles.labelText}>
            {strings.duplicateinspectiontext}
          </span>
        </div>
        <div className={styles.saveDiv}>
          <div className={styles.buttonHolder}>
            <button
              className={styles.saveSpan}
              onMouseDown={() => this.updateInspectionData()}
            >{strings.save}</button>
            <button
              className={styles.cancelSpan}
              onMouseDown={() => this.props.closeModal()}
            >{strings.cancel}</button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  inspectionsDataAll: state.assign.inspectionsData
});

export default connect(mapStateToProps, actions)(PopupDuplicateInspections);



// WEBPACK FOOTER //
// ./src/components/PopupDuplicateInspections/PopupDuplicateInspections.js